import module from 'cheques/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('cheques.listado', {
    url: '/lista?{fechaInicial:date}&{fechaFinal:date}&{idempresa}&{cuenta}&{estado}',
    data: {title: 'Cheques listado'},
    template: '<cheques-listado busqueda="$params"></cheques-listado>',
    controller: ($scope, $stateParams) => {
      $scope.$params = $stateParams
    },
  })
})



// WEBPACK FOOTER //
// ./src/cheques/routes/cheques/listado.js